@if (formData) {
  <div class="form-container">
    @for (formField of formData.formFields; track formField) {
      @if (isFormField(formField.formFieldType)) {
        <odin-dynamic-input
          [formField]="formField"
          [disabledInput]="disabledInput"
          (valueChanged)="ValueChanged()"
        ></odin-dynamic-input>
      } @else if (formField.formFieldType === 'SECTION') {
        <div class="d-flex align-items-center justify-content-start gap-2">
          <h5 class="sectionHeader">{{ formField.sectionName }}</h5>
          @if (formField.tooltipText) {
            <mat-icon
              [matTooltip]="formField.tooltipText"
              [matTooltipPosition]="'above'"
              [attr.aria-label]="formField.tooltipText"
              >info</mat-icon
            >
          }
        </div>
      } @else if (formField.formFieldType === 'DETAIL') {
        <div
          class="d-flex align-items-center justify-content-center gap-2 my-2"
        >
          <p class="sectionHeader my-0">{{ formField.sectionName }}</p>
          @if (formField.tooltipText) {
            <mat-icon
              [matTooltip]="formField.tooltipText"
              [matTooltipPosition]="'above'"
              [attr.aria-label]="formField.tooltipText"
              >info</mat-icon
            >
          }
        </div>
      }
    }
    @if (formData.submitButton) {
      <div [ngStyle]="{ 'text-align': formData.submitAlignment }">
        <div
          [ngStyle]="{ width: formData.submitSize, margin: SubmitAlignment() }"
          style="padding: 5px"
        >
          <button
            mat-flat-button
            [disabled]="!formValid"
            (click)="OnSubmit()"
            [color]="formData.theme"
            style="padding: 5px 20px; width: 100%"
            class="mon-bg-success mon-border-success border mon-text-success"
            data-test="core-dynamic-form-submit-button"
          >
            {{ formData.submitText }}
          </button>
        </div>
        @if (errorCount > 0) {
          <div>
            <p style="margin: 1.34375em 0; text-align: center; color: red">
              There are one or more errors in your form, please fix these and
              try again.
            </p>
          </div>
        }
      </div>
    }
    @if (formData.formError !== '') {
      <div class="mt-2">
        <p class="alert alert-danger text-center">{{ formData.formError }}</p>
      </div>
    }
  </div>
}
